import {
    AutocompleteArrayInput,
    AutocompleteInput,
    DateInput,
    Edit,
    ReferenceArrayInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileSearch, Users } from 'lucide-react';
import { required } from 'ra-core';

export const RFQEdit = () => {
    return (
        <Edit>
            <SimpleForm className="max-w-4xl mx-auto space-y-6">
                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-slate-50/50">
                        <div className="flex items-center gap-2">
                            <FileSearch className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Edit RFQ</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <TextInput source="reference" label="RFQ No." validate={required()} className="w-full font-mono" />
                            
                            <ReferenceInput source="project_id" reference="projects">
                                <AutocompleteInput label="Project" validate={required()} className="w-full" />
                            </ReferenceInput>

                            <ReferenceInput source="bom_id" reference="boms">
                                <AutocompleteInput label="Source BoM" className="w-full" />
                            </ReferenceInput>

                            <SelectInput 
                                source="status" 
                                label="Status" 
                                choices={[
                                    { id: 'draft', name: 'Draft' },
                                    { id: 'sent', name: 'Sent' },
                                    { id: 'replied', name: 'Replied' },
                                    { id: 'closed', name: 'Closed' },
                                    { id: 'cancelled', name: 'Cancelled' },
                                ]}
                                className="w-full"
                            />
                        </div>
                    </CardContent>
                </Card>

                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-slate-50/50">
                        <div className="flex items-center gap-2">
                            <Users className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Vendor Invitation</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-4">
                        <ReferenceArrayInput source="vendor_ids" reference="vendors">
                            <AutocompleteArrayInput label="Target Vendors" placeholder="Search and select multiple vendors..." className="w-full" />
                        </ReferenceArrayInput>
                        <TextInput source="notes" label="Special Instructions to Vendors" multiline rows={3} className="w-full" />
                        <DateInput source="due_date" label="Response Deadline" validate={required()} className="w-full" />
                    </CardContent>
                </Card>
            </SimpleForm>
        </Edit>
    );
};
